import { MODE_CARD, MODE_TABLE } from './GridManager';// eslint-disable-line no-unused-vars

export const TAB = 9;
export const END = 35;
export const HOME = 36;
export const LEFT_ARROW = 37;
export const UP_ARROW = 38;
export const RIGHT_ARROW = 39;
export const DOWN_ARROW = 40;
export const ENTER = 13;

export const isMovement = ({ key, which }) => {
    return ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End', RIGHT_ARROW, LEFT_ARROW, UP_ARROW, DOWN_ARROW, HOME, END]
        .reduce((match, code) => match || key === code || which === code, false);
};
export const addVectors = (...vectors) => {
    let vector = vectors.reduce((c, v = []) => {
        if (!v || !v.length || v.length !== c.length) throw new RangeError('Vectors must have exactly two dimensions');
        return c.map((value, index) => value + v[index]);
    }, [0, 0]);

    return vector;
};
export const createVectorConstraintCheck = (min, max) => {
    [min, max].forEach(v => {
        if (!v || v.constructor !== Array || v.length !== 2) throw new RangeError('createVectorConstraintCheck requires a min and a max, each with two members');
    });
    return (vector) => {
        if (!vector || vector.constructor !== Array || vector.length !== 2) throw new RangeError('createVectorConstraintCheck requires a vector with two dimensions');

        return vector.every((v, i) => v >= min[i] && v <= max[i]);
    };
};
export const getMovementVector = ({ key, which }) => {
    let vector;
    switch(key || which) {
        case 'ArrowRight':
        case RIGHT_ARROW:
            vector = [1, 0];
            break;
        case 'ArrowLeft':
        case LEFT_ARROW:
            vector = [-1, 0];
            break;
        case 'ArrowUp':
        case UP_ARROW:
            vector = [0, -1];
            break;
        case 'ArrowDown':
        case DOWN_ARROW:
            vector = [0, 1];
            break;
        case 'Home':
        case HOME:
            vector = [Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER];
            break;
        case 'End':
        case END:
            vector = [Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER];
            break;
        default:
            vector = [0, 0];
            break;
    }
    return vector;
};
export const isEnter = ({ key, which }) => (key === 'Enter' || which === ENTER);



// WEBPACK FOOTER //
// ./src/services/InputManager.js